import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-b1773e61-3c16-4a48-a7fc-f79abee5b97c-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-cc41610e-81fb-4580-b64c-04c8a8a81e34-__Layer_2_1_\"><g id=\"ec-09865131-e15c-4b4c-b4a1-16d04ab3c2d6-__Layer_1-2\"><g id=\"ec-c9778aba-00bd-4861-a06b-b15d61021113-__format_underlined\"><path d=\"m12.2 12h1.9v22.1c0 12.1 9.8 21.9 21.9 21.9s21.9-9.8 21.9-21.9v-22.1h1.9c1.7 0 3-1.3 3-3s-1.3-3-3-3h-9.8c-1.7 0-3 1.3-3 3s1.3 3 3 3h1.9v22.1c0 8.8-7.1 15.9-15.9 15.9s-15.9-7.1-15.9-15.9v-22.1h1.9c1.7 0 3-1.3 3-3s-1.3-3-3-3h-9.8c-1.7 0-3 1.3-3 3s1.4 3 3 3z\"></path><path d=\"m60 60h-48c-1.7 0-3 1.3-3 3s1.3 3 3 3h48c1.7 0 3-1.3 3-3s-1.3-3-3-3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }